import { useFetchLatestAppoinmentResults } from '@/api/hooks/useFetchLatestAppointmentResults'
import { AppHeader } from '@/components/AppHeader'
import { EmptyAppointmentResults } from '@/components/AppointmentResultsPage/EmptyAppointmentResults'
import { LockedAppointmentResults } from '@/components/AppointmentResultsPage/LockedAppointmentResults'
import { ViewableAppointmentResults } from '@/components/AppointmentResultsPage/ViewableAppointmentResults'
import ProtectedPage from '@/components/ProtectedPage'
import { analytics } from '@/lib/analytics'
import { Screen } from '@/ui/core/screen'
import { HStack, VStack } from '@/ui/core/stack'
import { Image } from 'expo-image'
import { useEffect } from 'react'
import Images from '#/assets/images/image-map'
export default function YourSmileScreen() {
	const { hasLockedResults, hasAppointmentResults, isLoadingResults, appointmentId } =
		useFetchLatestAppoinmentResults()

	useEffect(() => {
		if (!isLoadingResults) {
			analytics.trackEvent('viewed-appointment-results', {
				appointmentId: appointmentId ?? 'none',
				hasLockedResults: hasLockedResults?.valueOf() ?? false,
			})
		}
	}, [appointmentId, hasLockedResults, isLoadingResults])

	return (
		<ProtectedPage>
			<Screen preset="scroll">
				<HStack fullHeight>
					<Image
						style={{
							width: 16,
							height: 'auto',
						}}
						source={Images.VerticalDivider}
						contentFit="cover"
					/>
					<VStack fullWidth className="gap-24">
						<AppHeader className="bg-transparent" containerClassName="p-2" />
						<VStack
							gap={36}
							fullWidth
							className="items-center justify-start pr-4 lg:pr-0"
						>
							{!isLoadingResults && (
								<VStack fullWidth className="justify-center items-center">
									{!hasLockedResults && hasAppointmentResults && (
										<ViewableAppointmentResults />
									)}
									{hasLockedResults && <LockedAppointmentResults />}
									{!hasAppointmentResults && <EmptyAppointmentResults />}
								</VStack>
							)}
						</VStack>
					</VStack>
				</HStack>
			</Screen>
		</ProtectedPage>
	)
}
